export enum FormioComponentSelectors {
    TextArea = "formio-component-textarea",
    Tabs = "formio-component-tabs",
    SelectBoxes = "formio-component-selectboxes",
    Select = "formio-component-select",
    Radio = "formio-component-radio",
    Tags = "formio-component-tags",
    Address = "formio-component-address",
    DateTime = "formio-component-datetime",
    Day = "formio-component-day",
    Time = "formio-component-time",
    Survey = "formio-component-survey",
    Signature = "formio-component-signature",
    BodyMap = "formio-component-bodymap",
    PatientDateOfBirth = "formio-component-miproPatientDateOfBirth",
    SignatureField = "formio-component-miproSignatureField",
    PatientAddress = "formio-component-miproPatientAddressTextField",
    EpisodeNotesDatagrid = "formio-component-miproEpisodeNotesDatagrid",
    MiproConsultHistDatagrid = "formio-component-miproConsultHistDatagrid",
    MiproConsultHistDatagridV2 = "formio-component-miproConsultHistDatagridV2",
    MiproMedHistDatagrid = "formio-component-miproMedHistDatagrid",
    MiproMedHistDatagridInput = "formio-component-miproMedHistDatagridInput",
    ReviewerInput = "formio-component-reviewerInput"
}
